import { render, staticRenderFns } from "./ItemDetailSection.vue?vue&type=template&id=7551d26e&scoped=true"
import script from "./ItemDetailSection.vue?vue&type=script&lang=js"
export * from "./ItemDetailSection.vue?vue&type=script&lang=js"
import style0 from "./ItemDetailSection.vue?vue&type=style&index=0&id=7551d26e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7551d26e",
  null
  
)

export default component.exports